import {
  IFreezeCalculationsTableReport,
  IFreezeTablesProps,
  IFreezeTablesSearchParams,
} from "../../../Interfaces/freeze";
import { getFreezeCalculationsTable } from "../../../Requests/freeze";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { Additional } from "./Additional";

const FreezeCalculations = ({ searchParam }: IFreezeTablesProps) => {
  return (
    <TableTemplate<IFreezeTablesSearchParams, IFreezeCalculationsTableReport>
      refreshTableTime={5000}
      getDataTable={(searchParam, offset, pageSize, sortingType) =>
        getFreezeCalculationsTable(
          searchParam,
          offset,
          pageSize,
          sortingType || ""
        )
      }
      withSort
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={Additional}
          setSortingType={setSortingType}
          sortingType={sortingType}
        />
      )}
      searchParameters={searchParam}
    />
  );
};
export default FreezeCalculations;
